import mainLogo from "../images/Logo/EG-LOGO.webp";
import mainLogoWhite from "../images/Logo/EG-LOGO.webp";
import mobileLogo from "../images/Logo/EG-Logo-only2.webp";

export const stylesConfig = {
  mainLogo: mainLogo,
  mainLogoWhite: mainLogoWhite,
  mobileLogo: mobileLogo,
};
